"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CelebTabsFromJSON = CelebTabsFromJSON;
exports.CelebTabsFromJSONTyped = CelebTabsFromJSONTyped;
exports.CelebTabsToJSON = CelebTabsToJSON;
exports.CelebTabsToJSONTyped = CelebTabsToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function CelebTabsFromJSON(json) {
    return CelebTabsFromJSONTyped(json, false);
}
function CelebTabsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'tabLabel': !(0, runtime_1.exists)(json, 'tabLabel') ? undefined : json['tabLabel'],
        'tabContent': !(0, runtime_1.exists)(json, 'tabContent') ? undefined : json['tabContent'],
        'siteId': !(0, runtime_1.exists)(json, 'siteId') ? undefined : json['siteId'],
        'sequenceNumber': !(0, runtime_1.exists)(json, 'sequenceNumber') ? undefined : json['sequenceNumber'],
        'characters': !(0, runtime_1.exists)(json, 'characters') ? undefined : (json['characters'].map(_1.CharacterFromJSON)),
    };
}
function CelebTabsToJSON(value) {
    return CelebTabsToJSONTyped(value, false);
}
function CelebTabsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'tabLabel': value.tabLabel,
        'tabContent': value.tabContent,
        'siteId': value.siteId,
        'sequenceNumber': value.sequenceNumber,
        'characters': value.characters === undefined ? undefined : (value.characters.map(_1.CharacterToJSON)),
    };
}
